<mat-toolbar>
    <button id="btn-menu" mat-icon-button (click)="sidenav.toggle()">
    <span class="material-icons"> menu </span>
  </button>

    <div id="titleName">
        <h2>Mi cuenta</h2>
        <p>¡Hola! {{firebaseAuthService.publicUser.displayName}}</p>
    </div>
</mat-toolbar>

<mat-drawer-container class="example-container" [hasBackdrop]="diviceXs || diviceSm">

    <mat-drawer [mode]="!diviceXs && !diviceSm ? 'side' : 'over'" [opened]="!diviceXs && !diviceSm" #sidenav>
        <app-slider-menu></app-slider-menu>
    </mat-drawer>

    <mat-drawer-content>
        <div id="referred">

            <h1>Mis Referidos</h1>

            <div id="contentReferred" fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="space-around center" fxLayoutAlign.xs="space-around center">

                <mat-card class="cardReferred" *ngFor="let referred of referredUsers">

                    <div id="img-referred">

                        <img *ngIf="!referred.photoUrl" mat-card-image src="../../../../assets/img/profilePhoto/sinFoto.jpg">

                        <img *ngIf="referred.photoUrl" mat-card-image src="{{referred.photoUrl}}" [alt]="referred.displayName">

                    </div>

                    <mat-card-content>
                        <div id="referredInfo">
                            <h3>{{referred.displayName}}</h3>
                            <h4>{{referred.email}}</h4>
                        </div>
                    </mat-card-content>

                </mat-card>
            </div>

        </div>
    </mat-drawer-content>
</mat-drawer-container>